<template>
  <div class="order-review">
    <SfHeading :title="$t('Order review')" :level="3" />
    <template v-if="showStepReview(shippingAddress) || shippingMethod">
      <SfDivider class="divider" />
      <div class="m-base">
        <SfHeading class="sf-heading--left m-base" :title="$t('Shipping details')" :level="4" />
        <div v-if="showStepReview(shippingAddress)">
          <Address
            :address="shippingAddress.Name ? shippingAddress.Address : shippingAddress"
          />
          <p v-if="shippingAddress.Name">{{ shippingAddress.Name }}</p>
          <p v-if="shippingAddress.Description">{{ shippingAddress.Description }}</p>
        </div>
      </div>
      <div v-if="shippingMethod || shippingAddress.Name" class="m-base">
        <SfHeading class="sf-heading--left m-base" :title="$t('Shipping Methods')" :level="4" />
        <p v-if="shippingMethod">{{ shippingMethod }}</p>
        <p v-if="shippingAddress.Name">{{ $t('Pickup point') }}</p>
      </div>
    </template>
    <template v-if="showStepReview(billingAddress) || paymentMethod">
      <SfDivider class="divider" />
      <div class="m-base">
        <SfHeading class="sf-heading--left m-base" :title="$t('Payment details')" :level="4" />
        <div v-if="showStepReview(billingAddress)">
          <Address
            :address="billingAddress"
          />
        </div>
      </div>
      <div v-if="paymentMethod" class="m-base">
        <SfHeading class="sf-heading--left m-base" :title="$t('Payment Method')" :level="4" />
        <p>{{ paymentMethod }}</p>
      </div>
    </template>
    <template>
      <SfDivider class="divider" />
      <div class="m-base">
        <SfHeading class="sf-heading--left m-base" :title="$t('Totals')" :level="4" />
        <Totals />
      </div>
    </template>
  </div>
</template>
<script>
/* eslint-disable no-shadow */
import { SfHeading, SfDivider } from '@storefront-ui/vue';
import _ from 'lodash';
import { config } from '@/modules/core';
import { Address } from '@/modules/user';
import Totals from '../Totals.vue';

export default {
  name: 'OrderReview',
  mixins: [config],
  components: {
    SfHeading,
    SfDivider,
    Address,
    Totals,
  },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    shippingAddress: {
      type: Object,
      default: () => ({}),
    },
    billingAddress: {
      type: Object,
      default: () => ({}),
    },
    shippingMethod: {
      type: String,
      default: '',
    },
    paymentMethod: {
      type: String,
      default: '',
    },
  },
  methods: {
    showStepReview(config) {
      return !_.isEmpty(config);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

.order-review {
  box-sizing: border-box;
  width: 100%;
  box-shadow: 0 4px 11px rgba(var(--c-dark-base),.1);
  background: var(--c-light);
  padding: var(--spacer-base)
}

.divider {
  --divider-border-color: var(--c-white);
  --divider-width: 100%;
  --divider-margin: var(--spacer-sm) 0 var(--spacer-sm) 0;
}

.m-base {
  margin-top: var(--spacer-xs);
  margin-bottom: var(--spacer-xs);
}

/deep/ p {
  font: var(
    --link-font,
    var(--link-font-weight, var(--font-normal))
      var(--link-font-size, var(--font-sm)) / var(--link-font-line-height, 1.4)
      var(--link-font-family, var(--font-family-secondary))
  );
  margin-bottom: var(--spacer-sm);
  &:last-child {
    margin: 0;
  }
}

</style>
